(function () {
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var observers = new WeakMap();

  function initGallery(section) {
    var gallery = section.querySelector('[data-mm-gallery]');
    var dots = section.querySelector('[data-mm-gallery-dots]');
    if (!gallery || !dots) return;

    var slides = Array.prototype.slice.call(gallery.querySelectorAll('.mm-main-product-v2__slide'));
    if (slides.length < 2) return;

    /* Le carrousel défile en CSS sur mobile : sans point d'entrée au clavier, les
       visuels au-delà du premier restent hors de portée (WCAG 2.1.1). */
    gallery.setAttribute('tabindex', '0');

    var buttons = slides.map(function (slide, index) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'mm-main-product-v2__dot';
      dot.setAttribute('aria-label', index + 1 + ' ' + (dots.dataset.sliderOf || '/') + ' ' + slides.length);
      dot.addEventListener('click', function () {
        gallery.scrollTo({ left: slide.offsetLeft - gallery.offsetLeft, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
      });
      dots.appendChild(dot);
      return dot;
    });

    function setCurrent(index) {
      buttons.forEach(function (dot, position) {
        if (position === index) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    }

    setCurrent(0);
    if (!('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) setCurrent(slides.indexOf(entry.target));
      });
    }, { root: gallery, threshold: 0.6 });
    slides.forEach(function (slide) { observer.observe(slide); });
    observers.set(section, observer);
  }

  /* Le choix d'une variante se répercute côté client : passer par l'API de rendu
     de section rejouerait tout le markup et remettrait la galerie à zéro pour un
     simple changement de contenance. Les valeurs formatées (prix, visuels)
     viennent de Liquid, ce fichier ne fait que les appliquer. */
  function initVariants(section) {
    var picker = section.querySelector('[data-mm-variant-picker]');
    if (!picker) return;

    var variants = JSON.parse(picker.querySelector('[data-mm-variant-data]').textContent);
    var inputs = Array.prototype.slice.call(picker.querySelectorAll('.mm-variant-picker__input'));
    var labels = inputs.map(function (input) { return picker.querySelector('label[for="' + input.id + '"]'); });
    var unavailableText = picker.dataset.unavailableText;

    var idInput = section.querySelector('[data-mm-product-form] input[name="id"]');
    var buttons = Array.prototype.slice.call(section.querySelectorAll('[data-mm-add-to-cart], [data-mm-buy-now]'));
    var buttonLabel = section.querySelector('[data-mm-button-label]');
    var buttonPrice = section.querySelector('[data-mm-button-price]');
    /* Le bouton de paiement dynamique appartient à Shopify : on ne peut pas le
       désactiver, seulement le retirer tant que la combinaison choisie n'est
       pas achetable, sinon il part au checkout avec une variante fantôme. */
    var dynamicCheckout = section.querySelector('.shopify-payment-button');
    /* Le porteur du visuel de variante est marqué par le Liquid, et non déduit
       d'une classe de mise en page : c'est la diapo de la contenance courante,
       jamais la composition, qui reste la signature du produit. Le `sizes` et
       le jeu de largeurs de cette diapo sont donc ceux de la galerie, et
       l'échange n'a qu'une source à remplacer. */
    var image = section.querySelector('[data-mm-variant-media] img');
    var carrier = section.querySelector('[data-mm-variant-media]');
    /* La diapo de tête bascule de la composition signature au visuel plein de la
       contenance dès le premier choix, et n'en revient pas : la composition est
       l'image d'ARRIVÉE sur la fiche, pas un état où l'on retombe. Les largeurs
       annoncées suivent, sinon le navigateur choisirait sa source sur la mesure
       de la vignette composée. */
    var SIZES_PLEIN = '(min-width: 750px) 50vw, 100vw';
    /* Le bloc de prix est optionnel : la marchande peut ne pas l'avoir posé. On
       ne retient donc que son conteneur, et tout le reste s'en déduit — pas de
       demi-état où l'on écrirait un montant sans son intitulé. */
    var price = section.querySelector('[data-mm-price]');
    var priceCurrent = price && price.querySelector('[data-mm-price-current]');
    var priceCompare = price && price.querySelector('[data-mm-price-compare]');
    var priceCompareLabel = price && price.querySelector('[data-mm-price-compare-label]');
    var priceLabel = price && price.querySelector('[data-mm-price-label]');

    function position(input) {
      return Number(input.dataset.optionPosition) - 1;
    }

    /* Tableau creux assumé : une option sans choix laisse un trou, que `every`
       ignore. Une sélection partielle rend donc toutes les variantes compatibles. */
    function selection() {
      var values = [];
      inputs.forEach(function (input) {
        if (input.checked) values[position(input)] = input.value;
      });
      return values;
    }

    function matching(values) {
      return variants.filter(function (variant) {
        return values.every(function (value, index) { return variant.options[index] === value; });
      });
    }

    function refreshAvailability(values) {
      inputs.forEach(function (input, index) {
        var probe = values.slice();
        probe[position(input)] = input.value;
        var reachable = matching(probe).some(function (variant) { return variant.available; });
        labels[index].classList.toggle('mm-variant-picker__value--unavailable', !reachable);
        /* La mention d'indisponibilité est une zone live : réécrire un texte
           identique la ferait ré-annoncer à chaque changement de sélection,
           donc on ne touche au DOM que si l'état a vraiment changé. */
        var status = labels[index].querySelector('[data-mm-variant-status]');
        var message = reachable ? '' : unavailableText;
        if (status.textContent !== message) status.textContent = message;
      });
    }

    /* `fromChoice` distingue le tour d'INITIALISATION d'un vrai choix de
       l'internaute. Une seule notion pour deux effets, parce qu'ils répondent à
       la même question : est-ce que quelqu'un a cliqué ? Au chargement, ni
       l'URL ni le visuel de tête ne bougent — la galerie s'ouvre sur l'image
       principale du produit, telle que Liquid l'a rendue. Le prix, le bouton et
       la disponibilité, eux, se recalculent dans tous les cas : ils décrivent la
       variante que le formulaire porte déjà. */
    function update(fromChoice) {
      var values = selection();
      var variant = matching(values)[0] || null;
      var purchasable = Boolean(variant && variant.available);

      refreshAvailability(values);

      if (idInput) idInput.value = variant ? variant.id : '';
      buttons.forEach(function (button) { button.disabled = !purchasable; });
      if (dynamicCheckout) dynamicCheckout.hidden = !purchasable;
      if (buttonLabel) buttonLabel.textContent = purchasable ? buttonLabel.dataset.labelAvailable : buttonLabel.dataset.labelSoldOut;
      if (buttonPrice && variant) buttonPrice.textContent = variant.price;
      if (price && variant) {
        /* `compare_at_price` est déjà filtré par Liquid : il n'est renseigné que
           lorsqu'il dépasse le prix payé. La promotion se lit donc à sa seule
           présence, sans re-comparer deux montants déjà formatés en monnaie. */
        var onSale = Boolean(variant.compare_at_price);
        price.classList.toggle('mm-main-product-v2__price--on-sale', onSale);
        priceCurrent.textContent = variant.price;
        priceCompare.textContent = onSale ? variant.compare_at_price : '';
        priceCompare.hidden = !onSale;
        priceCompareLabel.hidden = !onSale;
        priceLabel.textContent = onSale ? priceLabel.dataset.labelSale : priceLabel.dataset.labelRegular;
      }
      if (fromChoice && image && variant && variant.image) {
        image.srcset = variant.srcset || '';
        image.sizes = SIZES_PLEIN;
        image.src = variant.image;
        /* La vue de la contenance est la SECONDE de la galerie, sous la
           composition signature : sans ce défilement, choisir une contenance ne
           montrerait rien puisque la vue concernée est hors écran. On y amène
           l'internaute, et il remonte d'une vue pour retrouver la signature. */
        carrier.scrollIntoView({ block: 'start', behavior: reducedMotion.matches ? 'auto' : 'smooth' });
      }

      /* L'URL ne suit que les choix de l'internaute : la réécrire au chargement
         ajouterait un paramètre que personne n'a demandé. */
      if (fromChoice && variant) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    /* LE DÉCLENCHEUR N'EST PAS « la variante a changé », C'EST « l'internaute a
       CHOISI ». La confusion des deux produisait le bug : la première contenance
       est déjà cochée à l'arrivée, donc cliquer dessus ne change aucune valeur,
       `change` ne part jamais (il n'est émis QUE lorsqu'un bouton radio devient
       coché) et la composition ne s'effaçait pas. Il fallait passer par une autre
       contenance puis revenir — retour Nolwenn du 26/08 : « je suis obligée de
       cliquer sur 200 puis sur 100 pour avoir la photo ».

       Les deux écouteurs couvrent deux gestes qu'aucun seul ne couvre : `change`
       porte le CLAVIER, où les flèches déplacent la sélection sans aucun clic ;
       `click` porte le re-clic sur une valeur déjà cochée. Sur un clic qui change
       la valeur, les deux se déclenchent : `update` recalcule tout depuis la
       sélection courante et n'écrit que des valeurs identiques, l'URL comprise
       (`replaceState`, donc aucune entrée d'historique en double). */
    function onChoice(event) {
      if (event.type === 'click' && !event.target.closest('.mm-variant-picker__value, .mm-variant-picker__input')) return;
      update(true);
    }

    picker.addEventListener('change', onChoice);
    picker.addEventListener('click', onChoice);
    update(false);
  }

  /*
   * Colonne d'informations collée à côté des visuels.
   *
   * Retour Alexia du 24/08 (PDF V2, remarque 16) : « défilement des images à
   * revoir, l'écran semble coupé en deux, ça donne l'impression d'un bug, il
   * faudrait que les deux parties ne soient pas scrollables (cf BDK) ». La
   * colonne portait `height: 100vh; overflow-y: auto`, donc un second conteneur
   * de défilement : la molette bougeait une moitié de l'écran et pas l'autre.
   *
   * Retirer le défilement interne ne suffit pas : une colonne collée plus haute
   * que la fenêtre rend son propre bas inatteignable. Le décalage de collage est
   * donc mesuré, pas supposé : une colonne trop haute se colle par le bas.
   */
  function initStickyInfo(section) {
    var info = section.querySelector('.mm-main-product-v2__info');
    if (!info || !section.classList.contains('mm-main-product-v2--sticky')) return;

    var desktop = window.matchMedia('(min-width: 750px)');

    /* Le décalage de collage se calcule en CSS (règle `is-sticky`) à partir de
       la hauteur de la colonne, seule mesure qui ne s'écrit pas en CSS.
       `is-sticky` cale la colonne en haut de sa ligne de grille : posée avant la
       mesure, la boîte se réduit à son contenu au lieu d'être étirée sur la
       hauteur de la galerie. Le collage lui-même ne change pas la hauteur. */
    var apply = function () {
      if (!desktop.matches) {
        info.classList.remove('is-sticky');
        info.style.removeProperty('--mm-info-height');
        return;
      }
      info.classList.add('is-sticky');
      info.style.setProperty('--mm-info-height', Math.ceil(info.getBoundingClientRect().height) + 'px');
    };

    apply();
    desktop.addEventListener('change', apply);
    /* Toute variation de hauteur de la colonne (accordéon, chargement des
       polices, changement de variante) change la réponse à « est-ce qu'elle
       tient ? ». Écrire la variable ne modifie que `top`, jamais la taille
       observée : pas de boucle. */
    if ('ResizeObserver' in window) new ResizeObserver(apply).observe(info);
  }

  function init(section) {
    if (section.dataset.mmProductReady) return;
    section.dataset.mmProductReady = 'true';

    initGallery(section);
    initStickyInfo(section);
    initVariants(section);

    var form = section.querySelector('[data-mm-product-form]');
    var heading = section.querySelector('.mm-main-product-v2__upsell-heading');
    var cards = Array.prototype.slice.call(section.querySelectorAll('.mm-main-product-v2__upsell'));

    if (heading && cards.length) {
      var track = document.createElement('div');
      track.className = 'mm-main-product-v2__upsells';
      heading.parentNode.insertBefore(track, heading.nextSibling);
      cards.forEach(function (card) { track.appendChild(card); });
    }

    /* L'ajout au panier depuis une carte existe déjà une fois pour tout le thème
       (assets/mm-card-add-to-drawer.js, chargé dans layout/theme.liquid) : on lui
       délègue le clic au lieu de réécrire un second chemin d'ajout. */
    section.addEventListener('click', function (event) {
      var card = event.target.closest('[data-mm-upsell-add]');
      if (card) window.MMCardAddToDrawer(card);
    });

    if (!form) return;
    form.addEventListener('submit', function (event) {
      var submitter = event.submitter || document.activeElement;
      var isBuyNow = submitter && submitter.hasAttribute('data-mm-buy-now');
      if (!submitter || (!submitter.hasAttribute('data-mm-add-to-cart') && !isBuyNow)) return;
      event.preventDefault();
      if (submitter.disabled) return;
      submitter.disabled = true;
      submitter.classList.add('is-loading');

      var formData = new FormData(form);
      formData.append('sections', 'cart-drawer,cart-icon-bubble');
      formData.append('sections_url', window.location.pathname);

      fetch(form.action + '.js', {
        method: 'POST',
        body: formData,
        headers: { Accept: 'application/json' }
      })
        .then(function (response) { return response.json(); })
        .then(function (data) {
          if (isBuyNow) {
            window.location.href = '/checkout';
            return;
          }
          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.renderContents === 'function') {
            drawer.renderContents(data);
            if (typeof drawer.open === 'function' && !drawer.classList.contains('is-open')) {
              drawer.open(submitter);
            }
          } else if (drawer && typeof drawer.refresh === 'function') {
            drawer.refresh({ open: true });
          } else {
            (window.MMPanierSecours || function () { window.location.href = '/cart'; })();
          }
          document.dispatchEvent(new CustomEvent('mm:cart-updated'));
        })
        .catch(function (e) {
          if (isBuyNow) { window.location.href = '/checkout'; return; }
          (window.MMPanierSecours || function () { window.location.href = '/cart'; })(e);
        })
        .finally(function () {
          submitter.disabled = false;
          submitter.classList.remove('is-loading');
        });
    });
  }

  document.querySelectorAll('[data-mm-product-v2]').forEach(init);

  /* Éditeur de thème : changer un réglage re-rend le HTML de la section sans
     ré-exécuter ce fichier. Sans ça, régler la hauteur des visuels ou la
     composition laisse le marchand devant une galerie sans pastilles. */
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-mm-product-v2]');
    if (section) init(section);
  });

  /* Symétrique : le HTML remplacé emporte les slides observés, on relâche
     l'observateur avec eux plutôt que de le laisser rattaché à du détaché. */
  document.addEventListener('shopify:section:unload', function (event) {
    var section = event.target.querySelector('[data-mm-product-v2]');
    var observer = section && observers.get(section);
    if (!observer) return;
    observer.disconnect();
    observers.delete(section);
  });
})();
